var _path, _g, _g2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStartIllustration = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 43,
  viewBox: "0 0 40 43",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.62628 12.1367L1.62624 34.505C1.62623 38.9522 5.23143 42.5574 9.67869 42.5574H30.3214C34.7686 42.5574 38.3738 38.9523 38.3738 34.505L38.3739 12.1367H1.62628Z",
  fill: "url(#paint0_linear_5094_23840)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b_5094_23840)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.7836 27.1744C26.7597 27.738 26.7597 29.1468 25.7836 29.7103L18.0972 34.1481C17.1211 34.7116 15.9011 34.0072 15.9011 32.8801L15.9011 24.0046C15.9011 22.8776 17.1211 22.1732 18.0972 22.7367L25.7836 27.1744Z",
  fill: "#1A2B7B"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b_5094_23840)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.62622 11.8801C1.62622 8.46649 4.3935 5.69922 7.8071 5.69922H32.1842C35.5978 5.69922 38.3651 8.46649 38.3651 11.8801V16.0456H1.62622V11.8801Z",
  fill: "url(#paint1_linear_5094_23840)",
  fillOpacity: 0.55
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3092 2.55859V8.41492M27.6821 2.55859V8.41492",
  stroke: "#1A2B7B",
  strokeWidth: 4.39225,
  strokeLinecap: "round"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b_5094_23840",
  x: 12.0949,
  y: 18.733,
  width: 18.2268,
  height: 19.4208,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 1.90305
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_5094_23840"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_5094_23840",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_b_5094_23840",
  x: 0.162139,
  y: 4.23514,
  width: 39.6671,
  height: 13.2758,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 0.732041
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_5094_23840"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_5094_23840",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_5094_23840",
  x1: 38.3739,
  y1: 12.1367,
  x2: -3.70052,
  y2: 29.4148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE0BB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD6F5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_5094_23840",
  x1: -108.14,
  y1: 130.839,
  x2: -75.097,
  y2: 159.95,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF33CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF971D"
})))));
export default SvgStartIllustration;